import { E } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { LoadingController } from '@ionic/angular';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { SearchService } from 'src/app/core/services/search.service';

@Component({
  selector: 'app-marketplace-cart',
  templateUrl: './marketplace-cart.component.html',
  styleUrls: ['./marketplace-cart.component.scss'],
})
export class MarketplaceCartComponent  implements OnInit {

  loader: HTMLIonLoadingElement;
  apicatalouge: any[] = [];
  imagePath: any;
  loading: boolean = false;
  breadcrumbList = [
    {
      label: 'Marketplace',
      embedurl: true,
      url: '/baseapp/marketplace'
    },
    {
      label: 'Cart',
      embedurl: false,
      url: ''
    }
  ];

  constructor(
    public storage: Storage,
    private backendService: BackendService,
    public helperService: HelperService,
    private router: Router,
    public searchService: SearchService,
    private loadingController: LoadingController
  ) { }

  ngOnInit() {
    this.getCartDetails();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get('token'),
      userId: await this.storage.get('id'),
      showDialog: await this.storage.get('showDialog'),
    };
    return data;
  }

  getCartDetails() {
    this.openLoader();
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId
      };
      this.backendService
        .PostAPICall('cartDetails', payload, storage.token)
        .subscribe(
          (data) => {
            
            if(data) {
              this.apicatalouge = data;
              this.imagePath = data.image;
              this.searchService.sendCartCount(data.length);
              this.loading = true;
              this.closeLoader();
            } else {
              this.searchService.sendCartCount(0);
              this.apicatalouge = [];
              this.loading = true;
              this.closeLoader();
            }
            
          },
          (error) => {
            //console.log(error);
            this.apicatalouge = [];
            this.loading = true;
            this.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  deleteFromCart(catalogId) {
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId,
        catalogue_id: catalogId
      };
      this.backendService
        .PostAPICall('deleteCart', payload, storage.token)
        .subscribe(
          (data) => {
            this.getCartDetails();
          },
          (error) => {
            this.helperService.handleError(error);
          }
        );
    });

  }

  catalogDetails(id) {
    this.router.navigate(['baseapp/marketplace/details/', id]);
  }

  async openLoader() {
    this.loader = await this.loadingController.create({
        message: 'Please wait...',
    });

    await this.loader.present();
    
    // Set a timeout to automatically dismiss the loader after 5 seconds
    setTimeout(async () => {
        await this.closeLoader();
    }, 5000);
  }

  async closeLoader() {
    if (this.loader) {
      await this.loader.dismiss(); 
    } else {
      //console.log('No loader to dismiss.');
    }
  }

}
